import { SelectInputOption } from '@/components/inputs/SelectInput';
import { UserStatus, UserStatusLabels } from '../enums';

export const userStatusOptions: SelectInputOption[] = [
  { label: UserStatusLabels[UserStatus.PENDING], value: UserStatus.PENDING },
  { label: UserStatusLabels[UserStatus.ACTIVE], value: UserStatus.ACTIVE },
  { label: UserStatusLabels[UserStatus.INACTIVE], value: UserStatus.INACTIVE },
  { label: UserStatusLabels[UserStatus.DELETED], value: UserStatus.DELETED },
];
